module.exports = __webpack_public_path__ + "img/8.be8c5f26.jpg";